import { IRGB } from '@picsart/rc/types/containerComponents/ShapeSidebar/types';

export const RGBAObjToFill = (rgba: IRGB): string =>
  `rgba(${rgba.r}, ${rgba.g}, ${rgba.b}, ${typeof rgba.a === 'number' ? rgba.a : 1})`;
